import { createFileRoute, Link, useParams } from '@tanstack/react-router'
import { ChevronRight } from 'lucide-react'
import TestDetailPage from '@/pages/(protected)/workspaces/[workspaceId]/compliance/tests/[testId]'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/employee-center/tests_/$testId',
)({
  component: RouteComponent,
  staticData: { employeeCenterLayout: 'fullBleed' },
})

// #1439 — a test (CES) assigned to the employee opens inside the Employee
// Center shell. Reuses the canonical TestDetailPage in `panelMode` (the same
// surface the main-panel overlay uses), so the employee stays in the EC nav
// instead of being thrown to the admin portal route.
function RouteComponent() {
  const { workspaceId, testId } = useParams({ strict: false }) as {
    workspaceId: string
    testId: string
  }
  return (
    <div className='flex h-full flex-col'>
      <div className='flex items-center gap-1.5 border-b border-border bg-card px-6 py-2.5 text-[12px]'>
        <Link
          to='/workspaces/$workspaceId/employee-center/tasks'
          params={{ workspaceId }}
          className='text-text-subtle hover:text-text-secondary'
        >
          Tasks
        </Link>
        <ChevronRight className='h-3 w-3 text-text-placeholder' />
        <span className='font-medium text-text-secondary'>Test</span>
      </div>
      <div className='min-h-0 flex-1'>
        <TestDetailPage
          panelMode
          workspaceId={workspaceId}
          testId={testId}
          testNavigationEnabled={false}
        />
      </div>
    </div>
  )
}
